import type { CoreProductAvailabilityResponseList } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Checks item availability for all Products.
 *
 * @endpoint GET /api/saas/me/products/availability
 * @scope saas
 * @see https://flecto.dev/api-4724231
 */

export async function getAllProductsAvailability(
  options: GetAllProductsAvailabilityOptions
): Promise<CoreProductAvailabilityResponseList> {
  const optionsWithDefaults: GetAllProductsAvailabilityOptions = {
    ...options,
    offset: options.offset ?? 0,
    limit: options.limit ?? 10000,
  }

  const { data } = await api.get<CoreProductAvailabilityResponseList>(
    '/api/saas/me/products/availability',
    {
      params: optionsWithDefaults,
    }
  )

  return data
}

export type GetAllProductsAvailabilityOptions = {
  q?: string
  limit?: number
  offset?: number
  start_at?: string
  end_at?: string
  quantity?: number
  ignore_booking_ids?: number[]
}
